import brl from './icons/brl.svg'
import gbp from './icons/gbp.svg'
import eur from './icons/eur.svg'
import usd from './icons/usd.svg'
import cad from './icons/cad.svg'
import hkd from './icons/hkd.svg'
import isk from './icons/isk.svg'
import php from './icons/php.svg'
import dkk from './icons/dkk.svg'
import huf from './icons/huf.svg'
import czk from './icons/czk.svg'
import ron from './icons/ron.svg'
import sek from './icons/sek.svg'
import inr from './icons/inr.svg'
import idr from './icons/idr.svg'
import rub from './icons/rub.svg'
import hrk from './icons/hrk.svg'
import jpy from './icons/jpy.svg'
import thb from './icons/thb.svg'
import chf from './icons/chf.svg'
import myr from './icons/myr.svg'
import bgn from './icons/bgn.svg'
import _try from './icons/try.svg'
import cny from './icons/cny.svg'
import nok from './icons/nok.svg'
import nzd from './icons/nzd.svg'
import zar from './icons/zar.svg'
import mxn from './icons/mxn.svg'
import sgd from './icons/sgd.svg'
import aud from './icons/aud.svg'
import ils from './icons/ils.svg'
import krw from './icons/krw.svg'
import pln from './icons/pln.svg'






export default {
    GBP: {
        name: "Libra Esterlina",
        iconUrl: gbp
    },
    BRL: {
        name: "Real Brasileiro",
        iconUrl: brl
    },
    EUR: {
        name: "Euro",
        iconUrl: eur
    },
    USD: {
        name: "Dólar Americano",
        iconUrl: usd
    },
    CAD: {
        name: "Dólar Canadense",
        iconUrl: cad
    },
    HKD: {
        name: "Dólar Hong Kong",
        iconUrl: hkd
    },
    ISK: {
        name: "Coroa Islandesa",
        iconUrl: isk
    },
    PHP: {
        name: "Peso Filipino",
        iconUrl: php
    },
    DKK: {
        name: "Coroa Dinamarquesa",
        iconUrl: dkk
    },
    HUF: {
        name: "Florim Húngaro",
        iconUrl: huf
    },
    CZK: {
        name: "Coroa Checa",
        iconUrl: czk
    },
    RON: {
        name: "Leu Romeno",
        iconUrl: ron
    },
    SEK: {
        name: "Coroa Sueca",
        iconUrl: sek
    },
    INR: {
        name: "Rúpia Indiana",
        iconUrl: inr
    },
    IDR: {
        name: "Rúpia Indonesiana",
        iconUrl: idr
    },
    RUB: {
        name: "Rublo Russo",
        iconUrl: rub
    },
    HRK: {
        name: "Kuna Croata",
        iconUrl: hrk
    },
    JPY: {
        name: "Iene Japonês",
        iconUrl: jpy
    },
    THB: {
        name: "Baht Tailandês",
        iconUrl: thb
    },
    CHF: {
        name: "Franco Suiço",
        iconUrl: chf
    },
    MYR: {
        name: "Ringgit Malaio",
        iconUrl: myr
    },
    BGN: {
        name: "Lev Búlgaro",
        iconUrl: bgn
    },
    TRY: {
        name: "Lira Turca",
        iconUrl: _try
    },
    CNY: {
        name: "Yuan Chinês",
        iconUrl: cny
    },
    NOK: {
        name: "Coroa Noroeguesa",
        iconUrl: nok
    },
    NZD: {
        name: "Dólar Neozelandês",
        iconUrl: nzd
    },
    ZAR: {
        name: "Rand Sul-africano",
        iconUrl: zar
    },
    MXN: {
        name: "Peso Mexicano",
        iconUrl: mxn
    },
    SGD: {
        name: "Dólar Singapura",
        iconUrl: sgd
    },
    AUD: {
        name: "Dólar Australiano",
        iconUrl: aud
    },
    ILS: {
        name: "Shekel Israelense",
        iconUrl: ils
    },
    KRW: {
        name: "Won Sul-coreano",
        iconUrl: krw
    },
    PLN: {
        name: "Zloty Polonês",
        iconUrl: pln
    }
}
